__turbopack_context__.v({
  "container": "dot-module__bN3FPW__container",
  "dot": "dot-module__bN3FPW__dot",
});
